import { render } from "./EditNewCompany.vue?vue&type=template&id=657bcd8a&scoped=true&ts=true"
import script from "./EditNewCompany.ts?vue&type=script&lang=ts"
export * from "./EditNewCompany.ts?vue&type=script&lang=ts"

import "./EditNewCompany.vue?vue&type=style&index=0&id=657bcd8a&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657bcd8a"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSelect,QBtn});
